<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useDecisionSupportWizardStore } from '../../stores/decision-support-wizard.store';
import DecisionSupportWizardParcelCard from './DecisionSupportWizardParcelCard.vue';
import DecisionSupportWizardApplyPrices from './DecisionSupportWizardApplyPrices.vue';

const decisionSupportWizardStore = useDecisionSupportWizardStore();
const { decisionSupportData, isParcelsLoading, isUiDisabled, cropNameByCode } = storeToRefs(decisionSupportWizardStore);
</script>

<template>
  <div class="h-100 d-flex flex-column">
    <div class="flex-grow-0">
      <v-row>
        <v-col
          cols="12"
          md="6">
          <v-card
            :title="$t('decisionSupport.wizard.label.crop')"
            :subtitle="cropNameByCode"
            variant="flat" />
        </v-col>
        <v-col
          cols="12"
          md="6">
          <v-card
            :title="$t('decisionSupport.wizard.label.year')"
            :subtitle="decisionSupportData.year ? decisionSupportData.year.toString() : '-'"
            variant="flat" />
        </v-col>
      </v-row>
      <v-row
        :no-gutters="true"
        class="mb-4">
        <v-col cols="12">
          <v-card variant="flat">
            <v-card-item>
              <div class="d-flex flex-row justify-space-between align-center">
                <v-btn
                  color="primary"
                  @click.prevent.stop="decisionSupportWizardStore.openParcelSelectorModal"
                  :loading="isParcelsLoading"
                  :disabled="isParcelsLoading || isUiDisabled">
                  {{ $t('decisionSupport.wizard.label.openParcels') }}
                </v-btn>
                <div>
                  <v-icon
                    icon="mdi-information"
                    id="icon"
                    color="blue"
                    class="mr-3"
                    size="x-large"
                    @click.stop.prevent="decisionSupportWizardStore.openInfoModal">
                  </v-icon>
                  <v-btn
                    variant="flat"
                    size="x-small"
                    :icon="true"
                    @click.prevent.stop="decisionSupportWizardStore.fitParcelsExtent()">
                    <v-icon
                      icon="mdi-magnify-minus-outline"
                      size="x-large" />
                  </v-btn>
                </div>
              </div>
            </v-card-item>
          </v-card>
        </v-col>
      </v-row>
      <v-divider />
      <decision-support-wizard-apply-prices />
      <v-divider />
    </div>
    <div class="flex-grow-1 position-relative mt-4 mb-4">
      <div
        class="h-100 position-absolute d-flex flex-column align-content-lg-space-between overflow-x-hidden gap-1 pl-4 pr-4 pb-4 pt-1"
        style="top: 0; left: 0; right: 0; bottom: 0; overflow-y: scroll">
        <transition-group name="application-data-items">
          <decision-support-wizard-parcel-card
            v-for="parcel in decisionSupportData.parcels"
            :key="parcel.id"
            :parcel="parcel"
            @removeParcel="decisionSupportWizardStore.removeParcel(parcel.id)"
            @zoomToExtent="decisionSupportWizardStore.zoomToExtent(parcel.bbox)" />
        </transition-group>
      </div>
    </div>
  </div>
</template>
